import AvatarCard from "@/ui/avatar-card";
import DateCell from "@/ui/date-cell";
import { createColumnHelper } from "@tanstack/react-table";
import { Checkbox, Text } from "rizzui";
import { Notification } from "@/types"; // Update import to Notification type
import { HOST_API_URL } from "config";
import TableRowActionGroup from "@/components/table-utils/table-row-action-group";
import routes from "@/routers/routes";

const columnHelper = createColumnHelper<Notification>();

export const serviceListColumns = [
    columnHelper.display({
        id: "select",
        size: 50,
        header: ({ table }) => (
            <Checkbox
                className="ps-3.5"
                aria-label="Select all Rows"
                checked={table.getIsAllPageRowsSelected()}
                onChange={() => table.toggleAllPageRowsSelected()}
            />
        ),
        cell: ({ row }) => (
            <Checkbox
                className="ps-3.5"
                aria-label="Select Row"
                checked={row.getIsSelected()}
                onChange={row.getToggleSelectedHandler()}
            />
        ),
    }),
    columnHelper.accessor("title", {
        id: "title",
        size: 150,
        header: "Title",
        enableSorting: false,
        cell: ({ row }) => (
            <AvatarCard
                src={""}
                name={row.original.title}
            />
        ),
    }),
    columnHelper.accessor("notificationType", {
        id: "notificationType",
        size: 150,
        header: "Notification Type",
        enableSorting: false,
        cell: ({ row }) => <Text>{row.original.notificationType}</Text>,
    }),
    columnHelper.accessor("message", {
        id: "message",
        size: 150,
        header: "Message",
        enableSorting: false,
        cell: ({ row }) => <Text>{row.original.message}</Text>, // Corrected to use message
    }),
    columnHelper.display({
        id: "actions",
        size: 120,
        cell: ({
            row,
            table: {
                options: { meta },
            },
        }) => (
            <TableRowActionGroup
                deletePopoverTitle="Delete the Notification"
                onDelete={() => {
                    meta?.handleDeleteRow?.(row.original);
                }}
                editUrl={routes.settings.services.edit(row.original.id ?? "")}
                deletePopoverDescription={`Are you sure you want to delete this #${row.original.id} Notification?`}
            />
        ),
    }),
];
